import script from "./PayPlanApply.vue?vue&type=script&setup=true&lang=ts"
export * from "./PayPlanApply.vue?vue&type=script&setup=true&lang=ts"

import "./PayPlanApply.vue?vue&type=style&index=0&id=1212bd9b&lang=less"

const __exports__ = script;

export default __exports__